// extracted by mini-css-extract-plugin
export default {"title":"kNBbt1","description":"FkxTlw","link":"s0p_l4","pinIcon":"_z0Thl","srOnly":"ELGmg6"};